import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Response } from '@angular/http';
import { LoginModel } from './login.model';
import { AuthService } from '../shared/services/auth.service';
import { ControlBase, ControlTextbox, ControlCheckbox } from '../shared/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { StorageService } from '../shared/services/storage.service';
import { UserService } from '../shared/services/user.service';
import { AngularFireAuth } from 'angularfire2/auth';


export interface ConfirmModel {
  title:string;
  message:string;
}
@Component({
    selector: 'appc-login',
    styleUrls: ['./login.component.scss'],
    templateUrl: './login.component.html'
})
export class LoginComponent   implements ConfirmModel,OnInit {
    loginModel: LoginModel;
    errors: string[];
    controls: any;
    title: string;
    loginmsg: string;
    message:string;

    constructor(    public userService:UserService,
                    public storageSvc:StorageService,
                    private auth: AuthService, 
                    private router: Router, 
                    private authService: AuthService,  
                    private storageService:StorageService, 
                    private route:ActivatedRoute,
                    private afAuth:AngularFireAuth
                     ) 
                    {
        
                        this.loginModel = new LoginModel('', '', false);
                    }

    login(model: any) {
        this.loginModel.email = model.email;
        this.loginModel.password = model.password;
        this.auth.emailLogin(this.loginModel.email.toString(),this.loginModel.password.toString())
            .then((result) => { 
                
            //console.log("Login Success")
            //console.log("this is result login "+JSON.stringify(result));

            this.route.params.subscribe((params: any) => {      
               let messageid = params['messageid'];
               switch(messageid){
                    case 'forumauth':
                    alert('forum auth')
            
                    this.router.routerState.root.queryParams.subscribe(queryparams => {
                        var accesstoken = this.storageService.getItem('tokenId');
                        this.afAuth.auth.currentUser.getToken(/* forceRefresh */ true).then(function (idToken) {
                        // Send token to your backend via HTTPS
            
                        let returnurl = queryparams['redirect_uri'];
                        let authurl = returnurl + "?token=" + idToken
                        // login successful so redirect to return url
                        console.log(" auth uri --> " + authurl)
                        window.location.href = authurl
                        // ...
                        }).catch(function (error) {
                        // Handle error
                        //todo route to proper page
                        });
                    
                    });
                    break;

                    case 'auth2eg':
                  
                        this.router.navigate(['/orgsearch']);

                    break;

                    case 'reset':
                
                        this.router.navigate(['/home']);
                    

                    break;


                }

            
          
              });

              this.router.navigate(['/home']);
          
                
            }).catch( error => {
                //console.log(error)
                this.loginmsg = error.message
            });
    };



    ngOnInit() {

        this.route.params.subscribe(params => {
            let messageid=params['messageid'] ? params['messageid']:'';
            if(messageid && messageid ==='auth2reg'){

                this.loginmsg = "Please Login to register your organization" ; 
            } if(messageid && messageid ==='forumauth'){
                
                this.loginmsg = "Login in to proceed to forums" ; 
            }if(messageid && messageid ==='reset'){

                this.loginmsg = "Password Reset Successful. Please Login with your new password" ; 
            }

            else
            this.loginmsg = "Please login" ;
            
         });
        let controls: ControlBase<any>[] = [
            new ControlTextbox({
                key: 'email',
                label: 'Email',
                placeholder: 'Email',
                value: '',
                type: 'email',
                required: true,
                order: 1
            }),
            new ControlTextbox({
                key: 'password',
                label: 'Password',
                placeholder: 'Password',
                value: '',
                type: 'password',
                required: true,
                order: 2
            })
        ];

        this.controls = controls;
    }


    signup(){

        this.router.navigateByUrl("/register");
    }

}



// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/+login/login.component.ts